import { requireAuth } from '../../middlewares/dashboardMiddleware'

const routes = [

  {
    path: '/dashboard/',
    name: 'Homepage',
    component: () => import('../../views/dashboard/Homepage'),
    beforeEnter: requireAuth,
    meta: {
      title: "Homepage",
      layout: 'dashboard'
    }
  },

  {
    path: '/dashboard/quotes',
    name: 'Quotes',
    component: () => import('../../views/dashboard/MyQuotes'),
    beforeEnter: requireAuth,
    meta: {
      title: "Quotes",
      layout: 'dashboard'
    }
  },
  {
    path: '/dashboard/quotes/:id',
    name: 'Quote Details',
    component: () => import('../../views/dashboard/MyQuoteDetails'),
    beforeEnter: requireAuth,
    meta: {
      title: "Quote Details",
      layout: 'dashboard'
    }
  },

  {
    path: '/dashboard/settings',
    name: 'Settings',
    component: () => import('../../views/dashboard/MySettings'),
    beforeEnter: requireAuth,
    meta: {
      title: "Settings",
      layout: 'dashboard'
    }
  },

  {
    path: '/dashboard/projects/:projects_type',
    name: 'My Projects',
    component: () => import('../../views/dashboard/MyProjects'),
    beforeEnter: requireAuth,
    meta: {
      title: "My Projects",
      layout: 'dashboard'
    }
  },

  {
    path: '/dashboard/create_project/:type_of_project',
    name: 'Create New Project',
    component: () => import('../../views/dashboard/CreateProject'),
    props: true,
    beforeEnter: requireAuth,
    meta: {
      title: "New Project",
    },

  },

  {
    path: '/dashboard/order_sync',
    name: 'Order Sync',
    component: () => import('../../views/dashboard/OrderSync'),
    beforeEnter: requireAuth,
    meta: {
      title: "Order Sync",
      layout: 'dashboard'
    }
  },

  {
    path: '/dashboard/FAQ',
    name: 'FAQ',
    component: () => import('../../views/dashboard/FAQ'),
    beforeEnter: requireAuth,
    meta: {
      title: "dealer",
      layout: 'dashboard'
    }
  },

  {
    path: '/snapsheets-templates',
    name: 'SnapsheetsTemplates',
    component: () => import('../../views/dashboard/SnapsheetsTemplates'),
    meta: {
      title: "Snapsheets Templates",
    }
  },

  {
    path: '/dashboard/unauthorized',
    name: 'Forbidden',
    component: () => import('../../views/dashboard/Forbidden'),
    meta: {
      title: "Unauthorized",
      layout: 'dashboard'
    }
  },

  // Showrooms Redirect
  {
    path: '/:dealer([A-Z]{3}[0-9]{3})',
    name: 'Showroom',
    component: () => import('../../views/dashboard/Homepage'),
    beforeEnter: (to) => {
      const dealer = to.params.dealer;
      const showroomUrl = `${process.env.VUE_APP_SHOWROOM_URL}/${dealer}`;
      window.location.href = showroomUrl
    },
    meta: {
      title: "Showroom",
    }
  },

  // Resizer Redirect
  {
    path: '/dashboard/js/iframeResizer.js',
    beforeEnter: () => {
      window.location.href = `${process.env.VUE_APP_GAMEPLAN_URL}/js/iframeResizer.min.js`
    }
  },
]

//Set a meta tag for each route, we will use it in the Global BeforeEach route (router/index.js)
routes.forEach(route => { if (route.meta) route.meta.isDashboardRoute = true })

export default routes
